import React from 'react';

import LoadingIcon from 'icons/loading.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function GeneratingExportModal({ onClose }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'exports.components.GeneratingExportModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('close')}
          </TextButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-border-0 tw-border-b-1 tw-border-solid tw-border-grey-100 tw-p-6'>
        <p className='tw-mb-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
          {i18nT('title')}
        </p>
      </div>
      <div className='tw-flex tw-flex-col tw-items-center tw-gap-6 tw-p-6'>
        <div className='tw-apply-loading-spinner--blue-light tw-flex tw-items-center tw-justify-center'>
          <LoadingIcon height={41} width={41} />
        </div>
        <p className='tw-mb-0 tw-text-l tw-font-semibold tw-tracking-auto'>
          {i18nT('description')}
        </p>
        <p className='tw-mb-0 tw-text-m tw-font-normal tw-tracking-auto'>
          {i18nT('disclaimer')}
        </p>
      </div>
    </ModalBox>
  );
}

GeneratingExportModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
